import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
// import { resetRedirectPatientForm } from "~/actions/umc/patientForm";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { MDBSpinner } from "mdbreact";
import styles from "./style.module.scss";
import { resetPatientForm } from "~/store/patientForm/patientFormAction";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PatientUpdateMobile = Loadable({
  loader: () => import(/* mobile */ "~/components/desktop/pages/PatientUpdate"),
  loading: LoadableLoading
});
const PatientUpdateDesktop = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/PatientUpdate"),
  loading: LoadableLoading
});

class PatientUpdate extends Component {
  componentWillUnmount() {
    this.props.resetPatientForm();
  }

  render() {
    const { loading } = this.props;
    const { device } = this.props;
    if (loading) {
      return (
        <div className={styles.loading}>
          <MDBSpinner big />
        </div>
      );
    }
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <PatientUpdateMobile {...this.props} />
        ) : (
          <PatientUpdateDesktop {...this.props} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    patientForm: { loading }
  } = state;
  return {
    device: type,
    loading
  };
};

const PatientUpdateHelmet = withTitle({
  component: PatientUpdate,
  title: `${hospitalName.value} | Cập nhật hồ sơ bệnh nhân`
});

export default connect(mapStateToProps, {
  resetPatientForm
})(PatientUpdateHelmet);
